module.exports = __webpack_public_path__ + "media/images/partner-6-471ffd1882f097c62a3a7d4ef37e698c.png";